<template>
    <div>
        <div class="plugins-tips">
            <el-select v-model="query.priceType" @change="currentPriceType($event)" style="width: 100px; margin-right: 10px;">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
            <el-input v-model="query.priceRecordSearch" placeholder="Filter" @keyup.enter.native="handlePriceRecordSearch" class="handle-input mr10"></el-input>
            
            <el-button type="primary" icon="el-icon-search" @click="handlePriceRecordSearch">搜索</el-button>
            <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："ID, 用户ID"</span>
        </div>
        <el-table
            :data="PriceRecord.tableData"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="tableCellStyle"
            v-loading="PriceRecord.loading"
            stripe
        >
            <el-table-column prop="id" label="ID" align="center"></el-table-column>
            <el-table-column prop="userId" label="用户ID" align="center"></el-table-column>
            <el-table-column prop="content" label="记录内容" show-overflow-tooltip align="center"></el-table-column>
            <el-table-column prop="priceType" label="货币类型" align="center">
                <template slot-scope="{row}">
                    <span v-if="row.priceType == 0">免费</span>
                    <span v-if="row.priceType == 1">付费</span>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat" align="center"></el-table-column>
            
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="PriceRecord.pageIndex"
                :page-size="PriceRecord.pageSize"
                :total="PriceRecord.pageTotal"
                @current-change="handlePriceRecordPageChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { getPriceRecord} from '../../../api/gameconsole-mars.js'
import moment from 'moment'
export default {
    name: 'MarsPriceRecord',
    data: function(){
        return {
            options: [{
                value: '',
                label: '全部'
            }, {
                value: '0',
                label: '免费'
            }, {
                value: '1',
                label: '付费'
            }],
            query: {
                priceType: '',
                priceRecordSearch: '',  //银河车票记录搜索
            },
            //银河车票
            PriceRecord: {
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: true
            },
        }
    },
    created() {
        this.initPriceRecordData()
    },
    activated() {
        this.initPriceRecordData()
    },
    methods: {
        //初始化数据
        initPriceRecordData() {
            this.PriceRecord.loading = true
            //如果搜索框不等于 空, 添加搜索条件

            //发送请求
            let params = {'priceType': this.query.priceType, 'priceRecordSearch': this.query.priceRecordSearch, 
                          'pageIndex': this.PriceRecord.pageIndex, 'pageSize': this.PriceRecord.pageSize }
            getPriceRecord(params).then(res => {
                if(res.data.code == 200) {
                    this.PriceRecord.tableData = res.data.data.records
                    this.PriceRecord.pageTotal = res.data.data.total
                }
                this.PriceRecord.loading = false
            }).catch(err => {
                this.PriceRecord.loading = false
            })
        },

        //下拉框
        currentPriceType() {
            this.initPriceRecordData()
        },

        //搜索框
        handlePriceRecordSearch() {
            this.initPriceRecordData()
        },

        //上一页 or 下一页
        handlePriceRecordPageChange(pageIndex) {
            this.PriceRecord.pageIndex = pageIndex
            this.initPriceRecordData()
        },

        //el-Tbale 时间格式
        dateFormat(row, column) {
            let date = row[column.property]
            if (date == undefined) return ''

            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

        tableCellStyle(row, column) {
            if (row.column.label == '内容') {
                return {'cursor': 'pointer'}
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
</style>
